import { render } from "./RouterPage.vue?vue&type=template&id=6660479f"
import script from "./RouterPage.vue?vue&type=script&lang=js"
export * from "./RouterPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__